<template>
    <div class="analysis-page">
        <div class="sub-container">
<!--            <div class="breadcrumbs">-->
<!--                <ul>-->
<!--                    <li><a :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a></li>-->
<!--                    <li><img src="/assets/images/pagination-right.svg" alt=""/></li>-->
<!--                    <li>{{ category.category_languages[0].pivot.name }}</li>-->
<!--                </ul>-->
<!--            </div>-->
            <h1>{{ category.category_languages[0].pivot.name }}</h1>
        </div>
        <div class="analysis-page-top">
            <div class="sub-container">
                <div class="analysis-top-list">
                    <category-big-feature-article v-if="featuredArticles[0] != null"
                                                  :hide-author="isDebate"
                                                  :article="featuredArticles[0]"></category-big-feature-article>
                    <div class="analysis-small-left" v-if="!isDebate">
                        <category-small-feature-article v-if="featuredArticles[1] != null"
                                                        :article="featuredArticles[1]"></category-small-feature-article>
                        <category-small-feature-article v-if="featuredArticles[2] != null"
                                                        :article="featuredArticles[2]"></category-small-feature-article>
                    </div>
                    <div v-else class="col-md-4 col-sm-12">
                        <div class="columns-box web-view">
                            <h2 class="heading"><a href="#">{{ $t('debaters') }} </a></h2>
                            <div class="columns-section">
                                <debaters-article v-for="debate in featuredArticles[0].debates"
                                                  :debate="debate" :article="featuredArticles[0]"></debaters-article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="analysis-listing">
            <div class="sub-container">
                <div class="row">
                    <div class="col-md-8 col-sm-7">
                        <form :action="$store.state.hrefPrefix + '/category/' + category.slug" method="get">
                            <div class="analysis-listing-top search-row">
                                <div class="analysis-search">
                                    <input type="text" :placeholder="$t('search') " name="filter" id="filter" v-model="filter"/>
                                    <input style="display: none" type="text" name="keyword" v-model="selectedTopic"/>
                                </div>
                                <div class="analysis-topic">
                                    <label>{{ $t('topic') }}</label>
                                    <select dir="ltr" v-model="selectedTopic">
                                        <option value="">{{ $t('all') }}</option>
                                        <option v-for="keyword in keywords" :value="keyword.slug">
                                            {{ keyword.keyword_languages[0].pivot.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="search-btn" style="margin-left: 10px">
                                    <button type="submit">{{ $t('search') }}</button>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <category-middle-feature-article v-for="article in middleArticles.data "
                                                             :article="article"></category-middle-feature-article>
                        </div>
                        <div class="pagination-row">
                            <a class="paginate-link" :href="middleArticles.links[0].url">&#60;</a>
                            <template v-for="(link, index) in middleArticles.links">
                                <a class="paginate-link" :href="link.url"><p :class="{'active' : link.active}"
                                                                             v-if="index !== 0 && index !== middleArticles.links.length - 1">
                                    {{ link.label }}</p></a>
                            </template>
                            <a class="paginate-link"
                               :href="middleArticles.links[middleArticles.links.length - 1].url">&#62;</a>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-5">
                        <div class="Subscribe-row" v-if="$store.state.language.code !== 'tr'">
                            <span>{{ $t('subscribe_to_our_newsletter') }}</span>
                            <form :action="$store.state.hrefPrefix + '/subscribe'" method="post" ref="subscribe" @submit.prevent="">
                                <input type="hidden" name="_token" :value="csrf">
                                <div class="Newsletter-input">
                                    <input type="text" :placeholder="$t('your_email_address')" name="email"/>
                                    <button class="g-recaptcha" data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                            data-callback="submitCategorySubscribe">{{ $t('cap_subscribe') }}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-12 col-sm-12" v-if="$store.state.language.code !== 'ar'">
                            <div class="columns-box web-view-poll" v-if="poll !== '' && poll != null">
                                <h2 class="heading" style="background-image: none;"><a>Poll</a></h2>
                                <div class="columns-section">
                                    <div class="columns-row">
                                        <poll :poll="poll"></poll>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <most-popular :articles="mostPopularArticle" :ad-Banner="mostPopularAd" :ad-banners="adBanners"></most-popular>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnalysisBigFeatureArticle from "@/parts/categories/CategoryBigFeatureArticle.vue";
import AnalysisSmallFeatureArticle from "@/parts/categories/CategorySmallFeatureArticle.vue";
import AnalysisMiddleFeatureArticle from "@/parts/categories/CategoryMiddleArticle.vue";
import MostPopularArticle from "@/parts/home/MostPopularArticle.vue";
import CategoryBigFeatureArticle from "@/parts/categories/CategoryBigFeatureArticle.vue";
import CategorySmallFeatureArticle from "@/parts/categories/CategorySmallFeatureArticle.vue";
import CategoryMiddleFeatureArticle from "@/parts/categories/CategoryMiddleArticle.vue";
import MostPopular from "@/parts/home/MostPopular.vue";
import ColumnArticle from "@/parts/Columns/ColumnArticle.vue";
import DebatersArticle from "@/parts/Columns/DebatersArticle.vue";
import Poll from "@/parts/Poll.vue";

export default {
    name: "CategoryPage",
    computed: {
        isDebate() {
            return this.category.slug === 'debates';
        },
        mostPopularAd(){
            return this.adBanners.find(banner => banner.placement === 'most_popular')
        },
    },
    components: {
        Poll,
        DebatersArticle,
        ColumnArticle,
        MostPopular,
        CategoryMiddleFeatureArticle,

        CategorySmallFeatureArticle,
        CategoryBigFeatureArticle,
        MostPopularArticle,
        AnalysisMiddleFeatureArticle, AnalysisSmallFeatureArticle, AnalysisBigFeatureArticle
    },
    props: {
        poll:{
          default: null
        },
        category: {
            type: Object,
            default: []
        },
        columnArticles: {
            type: Object,
            default: []
        },
        featuredArticles: {
            type: Array,
            default: []
        },

        featuredSmallArticles: {
            type: Object,
            default: []
        },

        middleArticles: {
            type: Object,
            default: []
        },

        mostPopularArticle: {
            type: Object,
            default: []
        },

        keywords: {
            type: Array,
            default: []
        },
        adBanners: {
            type: Array,
            default: []
        }

    },

    data() {
        return {
            //Get from query param
            filter: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            selectedTopic: null
        }
    },
    methods: {
        submitCategorySubscribe(response) {
            console.log(response)
            const form = this.$refs.subscribe;
            form.submit();
        }
    },
    mounted() {
        window.submitCategorySubscribe = this.submitCategorySubscribe;
        const urlParams = new URLSearchParams(window.location.search);
        this.filter = urlParams.get('filter');
        this.selectedTopic = urlParams.get('keyword') ?? '';
        if (urlParams.get('start_date') && urlParams.get('end_date')) {
            this.selectedDateValue = urlParams.get('date_value') ?? 'all';
            this.selectedDates = {
                startDate: urlParams.get('start_date'),
                endDate: urlParams.get('end_date')
            }
        }
    }
}
</script>

<style scoped>
.paginate-link:active, .paginate-link:hover, .paginate-link:focus, .paginate-link:visited, .paginate-link {
    color: #000;
}
.web-view-poll {
    display: block;
}

@media (max-width: 960px) {
    .web-view-poll {
        display: block !important;
    }
}

@media (max-width: 767px) {
    .web-view-poll {
        display: block !important;
    }
}

</style>
